import { OnInit, } from '@angular/core';
import { Auth } from '@freelancer/auth';
import { Datastore, } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { toNumber } from '@freelancer/utils';
import { ProjectTypeApi } from 'api-typings/projects/projects';
import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';
var HourlyAwardModalComponent = /** @class */ (function () {
    function HourlyAwardModalComponent(auth, datastore, modalRef) {
        this.auth = auth;
        this.datastore = datastore;
        this.modalRef = modalRef;
    }
    HourlyAwardModalComponent.prototype.ngOnInit = function () {
        this.payingHourly = true;
        this.bidDoc = this.datastore.document('bids', this.bidId);
        var bidderId$ = this.bidDoc.valueChanges().pipe(map(function (b) { return b.bidderId; }));
        this.userDoc = this.datastore.document('projectViewUsers', bidderId$);
        this.projectDoc = this.datastore.document('projectViewProjects', this.bidDoc.valueChanges().pipe(map(function (b) { return b.projectId; })));
        this.payload$ = Rx.combineLatest([
            this.bidDoc.valueChanges(),
            this.userDoc.valueChanges(),
            this.projectDoc.valueChanges(),
        ]).pipe(map(function (_a) {
            var bid = _a[0], user = _a[1], project = _a[2];
            return ({
                bid: bid,
                user: user,
                project: project,
            });
        }));
        var escrowRequired$ = this.datastore
            .objects('users', Rx.combineLatest([this.auth.getUserId(), bidderId$]).pipe(map(function (_a) {
            var authUid = _a[0], bidderId = _a[1];
            return [toNumber(authUid), bidderId];
        })))
            .pipe(map(function (users) { return users.some(function (u) { return u.escrowComInteractionRequired; }); }));
        this.showNormalAwardModal$ = escrowRequired$.pipe(map(function (escrowRequired) { return !escrowRequired; }));
    };
    HourlyAwardModalComponent.prototype.close = function (event) {
        this.modalRef.close(event);
    };
    HourlyAwardModalComponent.prototype.switchAwardType = function (awardType) {
        this.payingHourly = awardType === ProjectTypeApi.HOURLY;
    };
    return HourlyAwardModalComponent;
}());
export { HourlyAwardModalComponent };
